module.exports = __webpack_public_path__ + "media/tentacle.7e432edd.mp3";